import React from "react";
import "./portfolio-footer.styles.css";

const PortfolioFooter = () => (
  <footer className="footer">
    <div className="c sy">© 2026 Pankaj Vyas.</div>
  </footer>
);

export default PortfolioFooter;
